import React from "react";
import PropTypes from "prop-types";
import { Typography, Grid, Tooltip } from "@material-ui/core";
import { makeStyles } from "@material-ui/styles";
import { useTranslation } from "react-i18next";
import Done from "../../icons/Done";
import WarningFull from "../../icons/WarningFull";

const useStyles = makeStyles(theme => ({
  infoContainer: {
    "& .subLabel": {
      fontWeight: "600",
      fontSize: "0.8rem",
      color: "rgba(0, 0, 0, 0.84)",
      marginBottom: "0.4rem"
    },
    "& .subLabel:not(:first-child)": {
      marginTop: "1rem"
    }
  },
  iconSuccess: {
    color: "green",
    fontSize: "16px",
    marginBottom: '-2px',
    marginLeft: '1rem',
  },
  iconWarning: {
    color: theme.palette.secondary.main,
    fontSize: "16px",
    marginBottom: '-2px',
    marginLeft: '1rem',
  }
}));

const UserBillingInfo = props => {
  const { info } = props;
  const classes = useStyles();
  const { t } = useTranslation();

  return (
    <Grid container>
      <Grid item xs={12} md={6} className={classes.infoContainer}>
        <Typography component="h6" className="subLabel">
          {t("address")}
        </Typography>
        <Typography variant="body1">
          {info.FirstName} {info.LastName}
        </Typography>
        {info.CustomerType === 1 ? (
          <Typography variant="body1">{info.CompanyName}</Typography>
        ) : null}

        <Typography variant="body1">{info.AddressLine1}</Typography>
        <Typography variant="body1">{info.AddressLine2}</Typography>
        <Typography variant="body1">{info.AddressLine3}</Typography>
        <Typography variant="body1">
          {info.AddressCity}, {info.AddressState}, {info.AddressZipCode}
        </Typography>
        <Typography variant="body1">{info.CountryName}</Typography>
      </Grid>
      <Grid item xs={12} md={6} className={classes.infoContainer}>
        <Typography component="h6" className="subLabel">
          {t("email")}
        </Typography>
        <Typography variant="body1">{info.Email}</Typography>
        <Typography component="h6" className="subLabel">
          {t("phoneNumber")}
        </Typography>
        <Typography variant="body1">{`${info.CountryPhoneCode} ${info.Phone}`}</Typography>

        {info.CustomerType === 1 ? (
          <>
            {info.Vat.Number ? (
              <>
                <Typography component="h6" className="subLabel">
                  {t("vatNumber")}
                </Typography>
                <Typography variant="body1">
                  {info.AddressCountryIsoCode}
                  {info.Vat.Number}

                  {info.Vat.IsVerified ? (
                    <Tooltip title={t("vatValid")} interactive>
                      <Done className={classes.iconSuccess} />
                    </Tooltip>
                  ) : (
                    <Tooltip title={t("vatInvalid")} interactive>
                      <WarningFull className={classes.iconWarning} />
                    </Tooltip>
                  )}
                </Typography>
              </>
            ) : null}
          </>
        ) : null}
      </Grid>
    </Grid>
  );
};

UserBillingInfo.propTypes = {
  info: PropTypes.object.isRequired
};

export default UserBillingInfo;
